import React from 'react';

export function StatCard({
  icon: Icon,
  label,
  children,
  testId,
  accent,
}: {
  icon: any;
  label: string;
  children: React.ReactNode;
  testId: string;
  accent?: boolean;
}) {
  return (
    <div
      data-testid={testId}
      className="bg-white/[0.02] backdrop-blur-xl border border-white/10 rounded-2xl p-6 h-full flex flex-col transition-colors hover:border-white/20 hover:bg-white/[0.04]"
    >
      <div className="flex items-center gap-3 mb-4">
        <div
          className={
            accent
              ? 'w-10 h-10 rounded-xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center'
              : 'w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center'
          }
        >
          <Icon className={accent ? 'w-5 h-5 text-cyan-400' : 'w-5 h-5 text-white/70'} strokeWidth={1.5} />
        </div>
        <p className="text-xs uppercase tracking-[0.2em] text-white/50">{label}</p>
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}
